<template>
  <el-dialog title="Cálculo de Finalização - Demonstrativo de Aluguel para Locatário" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="recibo.itensRecibo"
            empty-text="Nenhum item encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row>
            <el-table-column label="Tipo" prop="tipo" width="150" :formatter="labelTipoRecibo"/>
            <el-table-column label="Descrição" prop="nome"/>
            <el-table-column label="Valor" prop="valor" :formatter="labelValor" width="130"/>
          </el-table>
        </el-col>
      </el-row>

      <el-row style="text-align: right">
        <h4 style="padding-right: 10px">Total: {{ util.formatarValor(this.totalRecibo) }}</h4>
      </el-row>

    </el-form>
    <span slot="footer">
      <el-button @click="finalizarAluguelHandler" type="primary" size="small" round class="btn-box-shadow">Finalizar</el-button>
    </span>
  </el-dialog>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../../util/funcoes.js';
import { TIPO_ITEM_RECIBO } from "../../../util/constantes.js";

export default {
  props: {
    reciboFinalizacao: Object,
    possuiRestricoes: Boolean,
    disponibilizarImovel: Boolean,
    dataFinalizacao: String,
    visibility: Boolean,
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      recibo: this.reciboFinalizacao
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
    }),
    totalRecibo() {
      let total = 0.0;
      if(this.recibo.aluguel){
        this.recibo.itensRecibo.forEach(item => {
        if(item.tipo === "DEBITO"){
          total += item.valor;
        } else if(item.tipo === "CREDITO") {
          total -= item.valor;
        }
      });   
      }else{this.fechar("FALHA")}
      
      return total;
    },
    tipoItem() {
      return TIPO_ITEM_RECIBO; 
    },
    loading() {
      return this.$store.state.loading;
    },
    util() {
      return Util;
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
        'finalizar',
        'finalizarComRestricoes'
    ]),
    iniciar(){
      this.recibo = this.reciboFinalizacao
    },
    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    labelTipoRecibo(item){
      return Util.getLabel(this.tipoItem,item.tipo)
    },
    labelValor(item) {
      return Util.formatarValor(item.valor)
    },
    reset(){
      this.recibo = {
        itensRecibo: []
      }
    },
    finalizarAluguelHandler() {
      if(this.possuiRestricoes){
        this.finalizarComRestricoesHandler();
      } else {
        this.finalizarHandler();
      }
    },
    finalizarComRestricoesHandler(){
      this.$confirm("Você tem certeza que deseja finalizar este contrato em " + this.dataFinalizacao +" ?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        let params = {};
        
        params.id = this.recibo.aluguel.id;
        params.dataFim = this.dataFinalizacao
        params.mesSerie = this.recibo.mesSerie
        params.disponibilizarImovel = this.disponibilizarImovel;
        
        this.showLoading();
        this.finalizarComRestricoes(params)
        .then(resultado => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar('SUCESSO');
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
        }).catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
      });
    },
    finalizarHandler(){
      this.$confirm("Você tem certeza que deseja finalizar este contrato em " + this.dataFinalizacao +" ?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        let params = {};
        
        params.id = this.recibo.aluguel.id;
        params.dataFim = this.dataFinalizacao
        params.mesSerie = this.recibo.mesSerie
        params.disponibilizarImovel = this.disponibilizarImovel;
        
        this.showLoading();
        this.finalizar(params)
        .then(resultado => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar('SUCESSO');
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
        }).catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
      });
    },
    fechar(resultado) {
      this.reset();
      this.$emit('close',resultado);
    } 
  }
}
</script>
